import { render, staticRenderFns } from "./GpathSkillRecoList.vue?vue&type=template&id=495a2bfc"
import script from "./GpathSkillRecoList.vue?vue&type=script&lang=js"
export * from "./GpathSkillRecoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports